define('modules/payments/router',['require','exports','module','jquery','backbone','env'],function (require, exports, module) {
  "use strict";

  var $ = require("jquery"),
    Backbone = require("backbone"),
    Config = require("env");

  module.exports = Backbone.Router.extend({
    initialize: function () {},

    routes: {
      payments: "paymentsRedirect",
      "payments/*query": "paymentsRedirect",
    },

    paymentsRedirect: function () {
      location.href = Config.paymentsUrl + "account/products";
    },
  });
});

